import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import 'rxjs/Rx';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../../environments/environment';
import { Constantes } from '../../shared/constantes';

import { TipoIdentificacion } from '../../shared/models/tipo-identificacion';
import { Departamento } from '../../shared/models/departamento';
import { Municipio } from '../../shared/models/municipio';
import { Solicitud } from '../../shared/models/solicitud';
import { Mensaje } from '../../shared/models/mensaje';

@Injectable()
export class SolicitudService {
  api: string;
  servicio: string;

  constructor(private httpClient: HttpClient) {
    this.api = environment.api;
    this.servicio = Constantes.SERVICIO;
  }

  getTiposIdentificacionSolicitud(): Observable<TipoIdentificacion[]> {
    return this.httpClient.get<TipoIdentificacion[]>(this.api + this.servicio + 'tiposIdentificacionSolicitud');
    // .map(
    // (data) => {
    //   const respuesta: TipoIdentificacion[] = data;
    //   return respuesta;
    // }
    // );
  }

  getTiposIdentificacionSolicitante(): Observable<TipoIdentificacion[]> {
    return this.httpClient.get<TipoIdentificacion[]>(this.api + this.servicio + 'tiposIdentificacionSolicitante');
  }

  getDepartamentos(): Observable<Departamento[]> {
    return this.httpClient.get<Departamento[]>(this.api + this.servicio + 'departamentos');
  }

  getMunicipios(idDepartamento: string): Observable<Municipio[]> {
    return this.httpClient.get<Municipio[]>(this.api + this.servicio + `municipios/${idDepartamento}`);
  }

  validarConductorSolicitud(tipoIdentificacion: string, numeroIdentificacion: string): Observable<string> {
    return this.httpClient.get<string>(this.api + this.servicio + 'validacionConductor/${tipoIdentificacion}/${numeroIdentificacion}');
  }

  validarConductor(solicitud: Solicitud): Observable<Mensaje> {
    return this.httpClient.post<Mensaje>(this.api + this.servicio + 'solicitud', solicitud);
  }

  generarSolicitud(solicitud: Solicitud): Observable<Mensaje> {
    // const headers = new HttpHeaders().set('Authorization', 'Bearer afdklasflaldf');
    // const options = { params: new HttpParams().set('confirm', confirm) };
    // let json = JSON.stringify(solicitud);

    return this.httpClient.post<Mensaje>(this.api + this.servicio + 'solicitud', solicitud);
  }

  continuarGeneracionSolicitud(solicitud: Solicitud): Observable<Mensaje> {
    return this.httpClient.post<Mensaje>(this.api + this.servicio + 'continuarSolicitud', solicitud);
  }

  getParametros(clave: string): Observable<any> {
    return this.httpClient.get<any>(this.api + this.servicio + `parametro/${clave}`);
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/public/services/solicitud.service.ts